import { Controller } from "@hotwired/stimulus"
import { throttle } from 'lodash-es'

export default class extends Controller {
  static values = {
    minY: Number,
    className: String,
    throttleDelay: Number
  }

  initialize () {
    this.lastScrollY = window.scrollY
    this.handleScroll = this.handleScroll.bind(this)
  }

  connect () {
    this.className = this.classNameValue || 'is-scrolling'
    const throttleDelay = this.throttleDelayValue || 15
    this.handleScroll = throttleDelay > 0 ? throttle(this.handleScroll, throttleDelay) : this.handleScroll

    window.addEventListener('scroll', this.handleScroll)
  }

  disconnect () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll () {
    const currentScrollY = window.scrollY
    const minY = this.minYValue || 120

    if (currentScrollY > minY && currentScrollY > this.lastScrollY) {
      this.element.classList.add(this.className)
    } else if (currentScrollY < this.lastScrollY) {
      this.element.classList.remove(this.className)
    }

    this.lastScrollY = currentScrollY
  }
}
